import type { LeaderboardQueryParams } from "@membentry/shared-types";

/** React Query key factory for leaderboard. */
export const LEADERBOARD_QUERY_KEY = "leaderboard";

export const leaderboardQueryKey = (params: LeaderboardQueryParams) =>
  [LEADERBOARD_QUERY_KEY, params.clubId, params.period, params.page, params.pageSize] as const;
